/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2019, Zumper
 * @description PreserveFiltersLink
 */

import PreserveFiltersLink from './PreserveFiltersLink'

export default PreserveFiltersLink
